import gql from 'graphql-tag'

import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

const PAGE_CHECK_QUERY = gql`
  query PageCheck($path: PagePath!) {
    page(path: $path) {
      path
    }
  }
`

export const checkForPrefixedPageMatch = async (
  requestPath: string,
  apollo: ApolloClient<NormalizedCacheObject>,
) => {
  const pathParts = requestPath.replace(/^\/|\/$/g, '').split('/')
  // Remove first item, already been validated against current page
  pathParts.shift()

  while (pathParts.length > 0) {
    try {
      const { data } = await apollo.query<{ page: { path: string } }>({
        query: PAGE_CHECK_QUERY,
        variables: {
          path: `/${pathParts.join('/')}`,
        },
      })

      if (data?.page) {
        return data.page.path
      }
    } catch {}

    pathParts.shift()
  }

  return null
}
